<div #viewContainer>
  <div class="view-page" [ngClass]="{
      'view-page--column-in': columnVisible,
      'view-page--column-out': !columnVisible, 
      'view-page--drawer-push': drawerVisible
    }"
    #view>

    <!-- Columns -->
    <app-view-column-container *ngIf="columnVisible || searchVisible || nodeInfoVisible"></app-view-column-container>

    <app-view-menu-column></app-view-menu-column>

    <!-- Title Only -->
    <div class="view-page__title-only" *ngIf="titleOnlyVisible && (chapter$ | async)?.info.displayName">
      <app-view-title layout="column"></app-view-title>
    </div>

    <!-- Engine -->
    <div class="view-page__engine" #engineContainer>

      <!-- Currently hardcoded to tutorial, may need to extend later -->
      <div class="view-page__notifications" *ngIf="(selectedChapterReady$ | async)?.model && !(tutorialSeen$ | async)">
        <app-notification [notification]="notification" (closeClick)="handleNotificationClose($event)"></app-notification>
      </div>


      <div class="view-page__undo" *ngIf="undoVisible">
        <app-view-undo></app-view-undo>
      </div>

      <!-- Column toggle -->
      <div class="view-page__column-toggle">
        <app-view-column-toggle></app-view-column-toggle>
      </div>
      
      <div class="view-page__scene-base" #viewSceneBase>
        <!-- Toolbar -->
        <div class="view-page__toolbar" #viewToolbar>
          <app-view-toolbar position="right" *ngIf="toolbarVisible"></app-view-toolbar>
        </div>

        <!-- Menu -->
        <div class="view-page__menu" *ngIf="menuVisible">
          <app-view-menu class="ml-4"></app-view-menu>
        </div>
        
        <!-- Logo -->
        <div class="view-page__logo" *ngIf="logoVisible">
          <app-view-logo
            [logoColor]="isBackgroundLight ? 'color' : 'white'"
            [logoSize]="(breakpoint$ | async) > breakpoint.Small ? 'full' : 'small'"
          ></app-view-logo>
        </div>
        
        <!-- Camera Bar -->
        <div class="view-page__camera-bar" #viewCameraBar>
          <app-engine-camera-bar
            *ngIf="cameraVisible" 
            [showNav]="cameraVisible">
          </app-engine-camera-bar>
        </div>
      </div>


      <!-- Drawer -->
      <ng-container *ngIf="drawerVisible">
        <app-view-drawer 
          #drawer
          (offsetYChange)="handleDrawerOffsetChange($event)"></app-view-drawer>
      </ng-container>
    </div>
  </div>
</div>

<!-- Input blocker -->
<div class="view-block-input" *ngIf="!(inputEnabled$ | async)"></div>

<!-- Help -->
<app-view-help *ngIf="(viewWindow$ | async) === viewWindow.Help" [activeTab]="showHelpTab$ | async"></app-view-help>

<!-- On Demand -->
<app-view-ondemand
  *ngIf="(viewWindow$ | async) === viewWindow.OnDemand"
  [contentId]="contentId"
  [contentType]="contentType">
</app-view-ondemand>

<!-- Loading Progress -->
<app-view-progress
  *ngIf="(layout$ | async)?.loader.template === 'circle'"
  [show]="(viewWindow$ | async) === viewWindow.Loader"
  [percent]="loadProgress"></app-view-progress>

<!-- Loading Experience -->
<app-view-loader *ngIf="(viewWindow$ | async) === viewWindow.Interact">
  <!-- Loader: Play -->
  <app-play-loader *ngIf="(interactType$ | async) === 'play'" [percent]="loadProgress"></app-play-loader>

  <!-- Loader: Button -->
  <app-button-loader *ngIf="(interactType$ | async) === 'button'"></app-button-loader>

  <!-- Loader: Click to Interact -->
  <app-hand-loader *ngIf="(interactType$ | async) === 'hand'"></app-hand-loader>
</app-view-loader>

<!-- Getting Started Tutorial -->
<app-view-tour *ngIf="(viewWindow$ | async) === viewWindow.Tutorial">
</app-view-tour>

<app-view-annotate *ngIf="(viewWindow$ | async) === viewWindow.Whiteboard"></app-view-annotate>

<!-- Print Image -->
<app-view-print *ngIf="usePrintImage$ | async"></app-view-print>

<!-- Content Warning -->
<app-view-content-warning *appFlagApplication="application.All; mode:'include', native: nativePlatform.All"></app-view-content-warning>

<!-- Iphone 12 Warning -->
<app-view-iphone12-warning></app-view-iphone12-warning>